import axios from "axios";
const { VUE_APP_SHIELD_URL, VUE_APP_SPONSOR, VUE_APP_PERK_KEY } = process.env;

export default class ShieldService {
  static async newCreateStep(
    userData,
    benefData,
    planData,
    servicesData,
    step,
    tokenStep,
  ) {
    try {
      let url;
      const jsonData = {
        userData,
        benefData,
        planData,
        servicesData,
        step,
        sponsor: VUE_APP_SPONSOR,
      };

      if (servicesData.type == "create") {
        url = "/step/newCreate";
      } else if (servicesData.type == "update") {
        url = "/step/newUpdate";
      }

      const carroResponse = await axios.post(
        `${VUE_APP_SHIELD_URL}${url}`,
        jsonData,
        {
          headers: {
            // Se agrega el header de autorización
            "x-captcha-authorization": tokenStep,
          },
        },
      );

      return carroResponse;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error en el servicio Stepers",
      };
    }
  }

  static async newGetStepAbandoned(stepId) {
    const shieldRes = await axios.get(
      `${VUE_APP_SHIELD_URL}/step/newGetAbandoned/${stepId}`,
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data;
    else throw shieldRes.data;
  }

  static async getPlans(category, age, code) {
    var maxAge = age;

    try {
      var url = `${VUE_APP_SHIELD_URL}/accidente`;
      var params = "";

      if (code) {
        params =
          url +
          `?sponsor=${VUE_APP_SPONSOR}&category=${category}&age=${maxAge}&code=${code}`;
      } else {
        params =
          url +
          `?sponsor=${VUE_APP_SPONSOR}&category=${category}&age=${maxAge}`;
      }
      const shieldRes = await axios.get(params);

      return shieldRes.data.status === "ok" ? shieldRes.data.data : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener los planes",
      };
    }
  }

  static async getPeople(personID) {
    try {
      const shieldRes = await axios.get(
        `${VUE_APP_SHIELD_URL}/person/get/${personID}`,
        {
          headers: { perk_key: VUE_APP_PERK_KEY },
        },
      );

      return shieldRes.data.status === "ok" ? shieldRes.data.data : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener los planes",
      };
    }
  }

  static async createContactActiveCampain(userData, servicesData) {
    try {
      const shieldRes = await axios.post(
        `${VUE_APP_SHIELD_URL}/activeCampain/createContact`,
        {
          userData,
          servicesData,
          sponsor: VUE_APP_SPONSOR,
        },
      );

      return shieldRes.data;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al crear el contacto",
      };
    }
  }

  static async updateContactActiveCampain(
    userData,
    planData,
    servicesData,
    index,
  ) {
    try {
      const shieldRes = await axios.put(
        `${VUE_APP_SHIELD_URL}/activeCampain/updateContact`,
        {
          userData,
          planData,
          servicesData,
          index,
          sponsor: VUE_APP_SPONSOR,
        },
      );

      return shieldRes.data;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al actualizar el contacto",
      };
    }
  }

  static async getContactActiveCampain(email) {
    try {
      const shieldRes = await axios.get(
        `${VUE_APP_SHIELD_URL}/activeCampain/getContact/${email}`,
      );

      return shieldRes.data;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al actualizar el contacto",
      };
    }
  }

  static async createInsurance(
    person,
    beneficiaries,
    plan,
    stepId,
    paymentMethod,
  ) {
    person.planName = person.PlanName;
    person.birthdate = person.dates;

    var BenefData = [];
    if (beneficiaries) {
      beneficiaries.forEach((benef) => {
        BenefData.push({
          name: benef.name,
          surname: benef.surname,
          rut: benef.rut,
          parentesco: benef.tipo,
          porcent: benef.porcentaje,
          fechaNacimiento:
            "" +
            benef.day.id +
            "-" +
            benef.month.number +
            "-" +
            benef.year.name,
        });
      });
      person.BenefDataAP = BenefData;
    }

    const jsonData = {
      person,
      planId: plan._id,
      stepId: stepId,
      paymentMethod,
    };

    const shieldRes = await axios.post(
      `${VUE_APP_SHIELD_URL}/accidente/createWithRunWayPayment`,
      jsonData,
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data.link;
    else throw shieldRes.data;
  }

  static async consultRutBlacklist(rut, token) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/blackList/consultRut`,
        {
          params: {
            rut,
          },
          headers: {
            "x-captcha-authorization": token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la lista negra.",
      };
    }
  }
  static async getPerson(rut) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/person/getByRut/${rut}`,
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la persona.",
      };
    }
  }
  static async getInsurance(personId) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/oncologico/getInsuranceByPerson/${personId}`,
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la insurance.",
      };
    }
  }
  static async checkHaveInsurance(rut) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/accidente/checkHaveInsurance?rut=${rut}&sponsor=${VUE_APP_SPONSOR}`,
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message || "Ocurrió un error al consultar.",
      };
    }
  }

  static async generateBrevoClient(personBody, stage, token) {
    try {
      const shieldResponse = await axios.post(
        `${VUE_APP_SHIELD_URL}/brevo/recurseContact`,
        {
          flowData: {
            ...personBody,
          },
          sponsor: VUE_APP_SPONSOR,
          stage,
        },
        {
          headers: {
            "x-captcha-authorization": token,
          },
        },
      );
      return shieldResponse.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la lista negra.",
      };
    }
  }
}
